import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
export function Hero() {
  return <section className="bg-white pt-6 pb-0 overflow-hidden" data-id="element-148">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center" data-id="element-149">

        {/* Badges */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-4" data-id="element-150">
          <div className="inline-flex items-center gap-2 bg-brand-pink-50 border border-brand-pink-200 px-3 py-1.5 rounded-full" data-id="element-151">
            <div className="flex" data-id="element-152">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-153" />)}
            </div>
            <span className="text-xs font-bold text-brand-pink-700" data-id="element-154">+2.000 mujeres ya lo hicieron</span>
          </div>
          <div className="inline-block bg-gray-100 text-gray-500 px-3 py-1.5 rounded-full text-xs font-semibold" data-id="element-155">
            Wall Pilates · 28 días
          </div>
        </div>

        {/* Headline */}
        <h1 className="font-display text-3xl md:text-5xl leading-tight text-gray-900 mb-3" data-id="element-156">
          Reducí la panza y transformá tu cuerpo en{' '}
          <span className="text-brand-pink-600" data-id="element-157">28 días</span>
          {' '}— desde casa, sin gym
        </h1>

        {/* Subheadline */}
        <p className="text-base md:text-lg text-gray-500 mb-2 max-w-xl mx-auto" data-id="element-158">
          Solo 20 minutos al día. Sin saltos. Sin lastimarte las rodillas. Sin dietas extremas.
        </p>

        <p className="text-brand-pink-600 font-bold text-base mb-6" data-id="element-159">
          "Por fin algo que puedo sostener."
        </p>

        {/* Imagen */}
        <div className="relative mx-auto max-w-xs mb-6" data-id="element-160">
          <img src="https://cdn.magicpatterns.com/uploads/jUEkp9AcBEThFUJD4CKtwQ/PORTADA_SHOPPY.png" alt="Programa Wall Pilates 28 días" className="w-full h-auto drop-shadow-2xl" data-id="element-161" />
        </div>

        {/* Precio */}
        <div className="bg-gray-50 border border-gray-200 rounded-2xl px-5 py-4 mb-5 max-w-sm mx-auto" data-id="element-162">
          <p className="text-xs text-gray-400 uppercase tracking-wide font-bold mb-1" data-id="element-163">Valor real del pack completo</p>
          <p className="text-xl font-bold text-gray-400 line-through mb-1" data-id="element-164">$139.890</p>
          <p className="text-xs text-brand-pink-600 font-bold uppercase tracking-wide mb-1" data-id="element-165">Precio especial de hoy</p>
          <p className="text-5xl font-black text-brand-pink-600 leading-none mb-2" data-id="element-166">$16.990</p>
          <div className="inline-block bg-yellow-400 text-gray-900 px-3 py-1 rounded-full text-sm font-extrabold" data-id="element-167">
            88% OFF — Solo por hoy
          </div>
          <div className="flex items-center justify-center gap-2 mt-3 text-xs text-gray-500" data-id="element-168">
            <span data-id="element-169">⏳ Termina en:</span>
            <CountdownTimer compact data-id="element-170" />
          </div>
        </div>

        {/* CTA */}
        <CTAButton size="large" className="w-full sm:w-auto" data-id="element-171">
          QUIERO EMPEZAR — $16.990
        </CTAButton>

        {/* Garantía */}
        <div className="flex items-center justify-center gap-2 mt-3 mb-4" data-id="element-172">
          <span className="text-lg" data-id="element-173">🛡️</span>
          <p className="text-sm text-gray-500 font-medium" data-id="element-174">
            Garantía de 7 días. Si no te gusta, te devolvemos el 100%.
          </p>
        </div>

        {/* Bullets */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 pb-8" data-id="element-175">
          {['✓ Acceso inmediato', '✓ Desde el celular', '✓ Sin equipamiento', '✓ 10 bonos incluidos'].map((item, i) => <span key={i} className="text-xs text-gray-500 font-medium" data-id="element-176">{item}</span>)}
        </div>
      </div>

      {/* Barra urgencia */}
      <div className="bg-brand-pink-600 text-white py-3 px-4 text-center" data-id="element-177">
        <p className="text-sm font-bold" data-id="element-178">
          ⚠️ Oferta válida solo por hoy — precio sube mañana
        </p>
      </div>
    </section>;
}